import * as types from './mutation-types'

export default {
  [types.SET_CONVERSATIONS] (state, payload) {
    const list = payload.data || payload
    state.conversations = list
    state.pagination = {
      next_cursor: payload.next_cursor || null,
      has_more: !!payload.has_more,
      total: payload.total !== undefined ? payload.total : list.length
    }
  },
  [types.APPEND_CONVERSATIONS] (state, payload) {
    const incoming = payload.data || payload
    // Dedup por id: uma conversa que recebeu mensagem nova pode ter subido
    // acima do cursor e vir repetida na página seguinte
    const known = {}
    state.conversations.forEach(c => { known[c.id] = true })
    const fresh = incoming.filter(c => !known[c.id])
    state.conversations = [...state.conversations, ...fresh]
    state.pagination = {
      ...state.pagination,
      next_cursor: payload.next_cursor || null,
      has_more: !!payload.has_more
    }
  },
  [types.SET_CONVERSATION] (state, payload) {
    state.conversation = payload
    if (payload) {
      state.sessionExpiresAt = payload.session_expires_at || null
      // Calculate session_active from expires_at if not provided
      if (payload.session_active !== undefined) {
        state.sessionActive = payload.session_active
      } else if (payload.session_expires_at) {
        state.sessionActive = new Date(payload.session_expires_at) > new Date()
      } else {
        state.sessionActive = false
      }
    }
  },
  [types.SET_MESSAGES] (state, payload) {
    state.messages = payload.data || payload
    if (payload.session_active !== undefined) {
      state.sessionActive = payload.session_active
      state.sessionExpiresAt = payload.session_expires_at
    }
  },
  [types.ADD_MESSAGE] (state, message) {
    const exists = state.messages.find(m => m.id === message.id)
    if (!exists) {
      state.messages.push(message)
    }
  },
  [types.PREPEND_MESSAGES] (state, messages) {
    const newMsgs = messages.filter(m => !state.messages.find(e => e.id === m.id))
    state.messages = [...newMsgs, ...state.messages]
  },
  [types.UPDATE_MESSAGE_STATUS] (state, payload) {
    const msg = state.messages.find(m => m.id === payload.message_id || m.wa_id === payload.wa_id)
    if (msg) {
      msg.status = payload.status
      msg.delivered_at = payload.delivered_at
      msg.read_at = payload.read_at
      msg.failed_at = payload.failed_at
    }
  },
  [types.UPDATE_CONVERSATION] (state, payload) {
    // Buscar por ID ou por phone (evita duplicatas de broadcasts diferentes)
    let idx = state.conversations.findIndex(c => c.id === payload.id)
    if (idx === -1 && payload.phone) {
      idx = state.conversations.findIndex(c => c.phone === payload.phone)
    }
    if (idx > -1) {
      state.conversations.splice(idx, 1, { ...state.conversations[idx], ...payload })
    } else {
      state.conversations.unshift(payload)
      state.pagination = { ...state.pagination, total: (state.pagination.total || 0) + 1 }
    }
    // Re-sort by last_message_at
    state.conversations.sort((a, b) => {
      return new Date(b.last_message_at) - new Date(a.last_message_at)
    })
  },
  [types.REMOVE_CONVERSATION] (state, id) {
    const before = state.conversations.length
    state.conversations = state.conversations.filter(c => c.id !== id)
    if (state.conversations.length < before) {
      state.pagination = { ...state.pagination, total: Math.max(0, (state.pagination.total || 0) - 1) }
    }
  },
  [types.SET_TEMPLATES] (state, payload) {
    state.templates = payload.data || payload
  },
  [types.SET_LOADING] (state, payload) {
    state.loading = payload
  }
}
